const config = {
  baseURL: 'https://pipe.mosol9.in/pied-app/api',
  Image_Base_URL: "https://pipe.mosol9.in/",
  Razorpay_Key: "rzp_test_Sfjn9Egx8rk62p"
  // baseURL: 'https://thepiedpiper.app/pied-app/api',
  // Image_Base_URL: "https://thepiedpiper.app/",
  // Razorpay_Key: "rzp_live_oWPqPh8C83xE1H"
}

export default config;